
import { toast } from "sonner";
import { PostgrestError } from "@supabase/supabase-js";

export interface ApiError extends Error {
  code?: string;
  details?: string;
  hint?: string;
  message: string;
}

export const handleFolderError = (error: PostgrestError | Error | unknown, defaultMessage: string): string => {
  const err = error as ApiError;
  console.error(defaultMessage, err);

  if (err.code === 'PGRST116') {
    return "Mappen hittades inte. Den kan ha tagits bort.";
  } else if (err.code === '23505') {
    return "En mapp med detta namn finns redan";
  } else if (err.code === '23503') {
    return "Kan inte ta bort mappen eftersom andra objekt refererar till den";
  } else if (err.message) {
    return `${defaultMessage}: ${err.message}`;
  }
  
  return defaultMessage;
};

export const handleAssessmentError = (error: PostgrestError | Error | unknown, defaultMessage: string): string => {
  const err = error as ApiError;
  console.error(defaultMessage, err);
  
  if (err.code === 'PGRST116') {
    return "Riskbedömningen hittades inte. Den kan ha tagits bort.";
  } else if (err.code === '23505') {
    return "Denna riskbedömning är redan länkad till denna mapp";
  } else if (err.code === '23503') {
    return "Mappen existerar inte längre";
  } else if (err.message) {
    return `${defaultMessage}: ${err.message}`;
  }
  
  return defaultMessage;
};

export const handleGenericError = (error: Error | unknown, defaultMessage: string): string => {
  console.error(defaultMessage, error);
  
  if (error instanceof Error && error.message) {
    return `${defaultMessage}: ${error.message}`;
  }
  
  return defaultMessage;
};

export const notifyError = (message: string): void => {
  toast.error(message);
};

export const notifySuccess = (message: string): void => {
  toast.success(message);
};
